import { forwardRef } from 'react';

import type { PlayerRosterForClubStore } from '@wwe-portal/entities/roster.type';
import { ResponsiveRosterCollection } from '@wwe-portal/ui/features/roster';

import { SectionLayout } from './section-layout';

export interface ExclusiveFuseupSectionProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  isLoading?: boolean;
  rosters?: PlayerRosterForClubStore[];
  total?: number;
  onItemClick: (id: string) => void;
  onViewMoreRosters: () => void;
}

export const ExclusiveFuseupSection = forwardRef<
  HTMLDivElement,
  ExclusiveFuseupSectionProps
>(
  (
    {
      title,
      description,
      total,
      rosters,
      isLoading,
      onItemClick,
      onViewMoreRosters,
    },
    ref
  ) => {
    return (
      <SectionLayout description={description} ref={ref} title={title}>
        <ResponsiveRosterCollection
          hasUpgradeIcon
          isLoading={isLoading}
          onItemClick={onItemClick}
          onViewMoreRosters={onViewMoreRosters}
          rosters={rosters}
          total={total}
        />
      </SectionLayout>
    );
  }
);

ExclusiveFuseupSection.displayName = 'ExclusiveFuseupSection';
